<template>
  <div class="indexApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" @resize="handleResize">
    <headComponent></headComponent>
    <div style="height:36px"></div>
    <div class="banner">
      <swiper :options="swiperOption">
        <swiper-slide class="swiper-slide">
          <a><img src="http://admin.4008005216.com//upload/20210712/d5abf3707215426c860b194f39cd648b.jpg"></a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav">
      <a @click="$router.push('lock')">
        <img src="~assets/images/kjk.png"/>
        <p>聚卡激活</p>
      </a>
      <a @click="$router.push('luggage')">
        <img src="~assets/images/luggage.png"/>
        <p>活动线路</p>
      </a>
      <a @click="$router.push('tindex')">
        <img src="~assets/images/mmp.png"/>
        <p>预约参加</p>
      </a>
      <a @click="$router.push('counts')">
        <img src="~assets/images/nav3.png"/>
        <p>图库围观</p>
      </a>
      <a @click="$router.push('import')">
        <img src="~assets/images/ry.png"/>
        <p>团长管理</p>
      </a>
      <div class="noty">
        <p><i class="el-icon-message-solid"></i>悠乐聚卡火热更新上线啦，更多板块持续上新！</p>
      </div>
    </div>

    <div class="active">
      <h2>
        <span class="curt">活动线路</span>
        <font>想玩的不一样，来这里</font>
      </h2>
      <ul>
        <li>
          <div class="images">
            <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          </div>
          <div class="txtCon">
            <div class="title">踏春户外体能课踏春户外体能课踏春户外体能课</div>
            <p>
              <span>亲子游</span>
              <span>海滨风光</span>
              <span>户外活动体验</span>
            </p>
            <p>带队老师：龙泽西</p>
            <p>时间：03-31 08:00 ~ 04-30 18:00</p>
            <p>
              <font>报名50人</font>
              <font class="last">报名中</font>
            </p>
          </div>
        </li>
        <li>
          <div class="images">
            <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          </div>
          <div class="txtCon">
            <div class="title">踏春户外体能课踏春户外体能课踏春户外体能课</div>
            <p>
              <span>亲子游</span>
              <span>海滨风光</span>
              <span>户外活动体验</span>
            </p>
            <p>带队老师：龙泽西</p>
            <p>时间：03-31 08:00 ~ 04-30 18:00</p>
            <p>
              <font>报名50人</font>
              <font class="last">报名中</font>
            </p>
          </div>
        </li>
        <li>
          <div class="images">
            <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          </div>
          <div class="txtCon">
            <div class="title">踏春户外体能课踏春户外体能课踏春户外体能课</div>
            <p>
              <span>亲子游</span>
              <span>海滨风光</span>
              <span>户外活动体验</span>
            </p>
            <p>带队老师：龙泽西</p>
            <p>时间：03-31 08:00 ~ 04-30 18:00</p>
            <p>
              <font>报名50人</font>
              <font class="last">报名中</font>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div class="active">
      <h2>
        <span class="curt">景区实况</span>
        <font>景在手中，尽在掌中</font>
      </h2>
      <dl>
        <dd>
          <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          <h3>南宁青秀区景区</h3>
          <p>南宁青秀区景区</p>
          <div class="price">￥20.00</div>
        </dd>
        <dd>
          <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          <h3>南宁青秀区景区</h3>
          <p>南宁青秀区景区</p>
          <div class="price">￥20.00</div>
        </dd>
        <dd>
          <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          <h3>南宁青秀区景区</h3>
          <p>南宁青秀区景区</p>
          <div class="price">￥20.00</div>
        </dd>
        <dd>
          <el-image style="width: 100%;border-radius:6px;height:135px" src="http://admin.4008005216.com//upload/20210617/6b03174403838c1a1ae9ccac145f2d6e.jpg" fit="cover"></el-image>
          <h3>南宁青秀区景区</h3>
          <p>南宁青秀区景区</p>
          <div class="price">￥20.00</div>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        dialogVisible:false,
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false,
            delay: 5000
          },
          initialSlide: 0,
          speed: 1000,
          loop:true,
          grabCursor: true,
          autoHeight: true,   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        bool:0,
      };
    },
    beforeMount() {
      this.baseUrl = this.$hostApi;
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      login:function(){
        var that = this;
        that.$httpWX.post({
          url: that.$hostApi+'home/login/login',
          method:'post',
          data:{
            code:that.code
          }
        }).then(response => {
          if(response.status == 200){
            localStorage.setItem('userjwt', response.data);
          }else{
            that.$alert(response.message, '提示');
          }
          that.fullscreenLoading = false;
        })
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  
  .indexApp{
    max-width:750px;
    background:#ececec;
    margin:0 auto;
  }
  .indexApp .banner{
    background:#fff;
  }
  .indexApp .banner .swiper-container{
    width:100% !important;
  }
  .indexApp .banner .swiper-slide{
    display:block;
  }
  .indexApp .banner img{
    display:block;
    width:100%;
    margin:0 auto;
    object-fit: cover;
    height:170px;
  }
  .indexApp .banner .swiper-pagination{
    bottom:10px
  }
  .indexApp .banner .swiper-pagination span{
    width:5px;
    height:5px;
    border-radius:5px;
  }
  .indexApp .banner .swiper-pagination span.swiper-pagination-bullet-active{
    width:15px;
    background:#fff;
    opacity:1
  }

  .indexApp .nav{
    width:100%;
    background:#fff;
    margin:0 auto;
    padding-bottom:12px
  }
  .indexApp .nav:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .indexApp .nav a{
    float:left;
    width:20%;
    margin-top:15px;
    text-decoration: none
  }
  .indexApp .nav a img{
    width:45px;
    display:block;
    margin:0 auto
  }
  .indexApp .nav a p{
    width:100%;
    text-align:center;
    font-size:14px;
    color:#1C222B;
    padding-top:2px;
  }
  .indexApp .noty{
    background:#fff;
    width:100%;
    padding-top:15px;
    clear:both;
  }
  .indexApp .noty p{
    width:95%;
    margin:0 auto;
    background:#f7f8fa;
    border-radius:6px;
    font-size:15px;
    padding:10px 0;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#6b6b6b
  }
  .indexApp .noty p i{
    color:#0059D6;
    font-size:20px;
    margin:0 3px 0 8px;
    vertical-align: top;
  }

  .indexApp .active{
    width:96%;
    margin:0 auto;
  }
  .indexApp .active h2{
    padding:10px 0 8px 0
  }
  .indexApp .active h2 span{
    position:relative;
    z-index: 1;
    margin-right:12px;
    font-size:16px;
    color:#666;
    font-weight:normal
  }
  .indexApp .active h2 span.curt{
    font-size:16px;
    color:#1C222B;
    font-weight:bold
  }
  .indexApp .active h2 span.curt:after{
    position: absolute;
    content: '';
    width: 35px;
    height: 10px;
    border-radius: 8px;
    background-color:#6b92ff;
    top: 51%;
    right: 0px;
    z-index: -1;
  }
  .indexApp .active h2 font{
    font-weight:normal;
    font-size:11px;
    color:#6b6b6b;
  }
  
  .indexApp .active ul{
    width:100%;
    display:block;
  }
  .indexApp .active ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .indexApp .active ul li{
    background:#fff;
    padding:12px;
    margin-bottom:12px
  }
  .indexApp .active ul li:last-child{
    margin-bottom:0;
  }
  .indexApp .active ul li .images{
    float:left;
    width:120px;
  }

  .indexApp .active ul li .txtCon{
    float:left;
    width:calc(100% - 130px);
    margin-left:10px
  }
  .indexApp .active ul li .txtCon .title{
    font-size:16px;
    color:#1C222B;
    font-weight:bold;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .indexApp .active ul li .txtCon p{
    font-size:14px;
    color:#6b6b6b;
    margin-top:10px
  }
  .indexApp .active ul li .txtCon p span{
    font-size:11px;
    background: #FEF3E6;
    color: #ED7B2F;
    margin-right:8px;
    padding:4px;
    border-radius: 4px;
  }
  .indexApp .active ul li .txtCon p font{
    font-size:11px;
    background: #F1F2F5;
    color: #1C222B;
    margin-right:10px;
    padding:4px;
    border-radius: 4px;
  }
  .indexApp .active ul li .txtCon p font.last{
    background: #ECF2FE;
    color: #0052D9;
  }
  .indexApp .active dl{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width:100%;
  }
  .indexApp .active dl dd{
    width:49%;
    background:#fff;
    border-radius: 6px;
    padding-bottom:10px
  }
  .indexApp .active dl dd h3{
    font-size:16px;
    width:92%;
    margin:0 auto
  }
  .indexApp .active dl dd p{
    font-size:14px;
    color:#6b6b6b;
    width:92%;
    margin:0 auto;
    padding-top:6px
  }
  .indexApp .active dl dd .price{
    font-size:14px;
    color:#f00;
    width:92%;
    margin:0 auto;
    font-weight:bold;
    padding-top:6px
  }
</style>